import Vue from 'vue'
import App from './App.vue'
import router from './router'
import axios from 'axios' //导入axios (用于前后端数据交互)
import leaflet from 'leaflet' // leaflet
import http from './assets/js/http.js' //封装axios
import common from './assets/js/common.js' //引入公共方法
import Loading from './components/loading/' //加载动画
import ElementUI from 'element-ui'; // elementUI样式
import store from "./store";


import '../public/static/elementStyle/theme/index.css'
// import 'element-ui/lib/theme-chalk/index.css';
import "leaflet/dist/leaflet.css" // leaflet
import './assets/css/_style.scss' //全局样式
import './assets/css/animate.min.css'

// 引入 leaflet.markercluster   聚类分析
import "leaflet.markercluster/dist/MarkerCluster.css"
import "leaflet.markercluster/dist/MarkerCluster.Default.css"
import "leaflet.markercluster";
import "leaflet.heat/dist/leaflet-heat.js"
import "leaflet.heat/src/HeatLayer.js"
import "leaflet.heat"

// 引入 Leaflet-MovingMaker 移动轨迹
import MovingMaker from "Leaflet-MovingMaker/MovingMarker.js"
// 引入 leaflet-heat.js：  热力图
import HeatmapOverlay from "leaflet-heatmap/leaflet-heatmap.js"
Vue.prototype.$HeatmapOverlay = HeatmapOverlay;
Vue.prototype.$leaflet = leaflet; // leaflet
// 引入 leaflet-polylinedecorator 线装饰
import "leaflet-polylinedecorator/dist/leaflet.polylineDecorator.js"
// 解决默认 maker 无法显示的问题
import icon from "leaflet/dist/images/marker-icon.png";
import iconShadow from "leaflet/dist/images/marker-shadow.png";
let DefaultIcon = leaflet.icon({
  iconUrl: icon,
  shadowUrl: iconShadow
});
leaflet.Marker.prototype.options.icon = DefaultIcon;

//引入滑动插件
import SlideVerify from 'vue-monoplasty-slide-verify';
Vue.use(SlideVerify);

// 引入echarts
import * as echarts from 'echarts'
Vue.prototype.$echarts = echarts;

Vue.config.productionTip = false;
Vue.use(ElementUI);
Vue.use(Loading); //加载动画

//多语言
import VueI18n from 'vue-i18n';
Vue.use(VueI18n);
const i18n = new VueI18n({
  locale: localStorage.getItem("language") || 'cn',
  messages: {
    'cn': require('./assets/lang/cn.json'),
    'tc': require('./assets/lang/tc.json'),
    'en': require('./assets/lang/en.json'),
    'jpn': require('./assets/lang/jpn.json')
  }
});

axios.defaults.timeout = 30000;
// axios.defaults.baseURL = 'http://localhost:8084/mc/';
axios.defaults.baseURL = '/api';
// axios.defaults.baseURL = 'http://localhost:5000';

//挂载 axios
Vue.prototype.$httpss = axios;
Vue.prototype.http = http; //封装axios
Vue.prototype.common = common; //引入公共方法


// 初始化参数
store.dispatch("getdictList");
store.dispatch("getCommons");
// store.dispatch("getTempleList");

new Vue({
  render: h => h(App),
  router,
  store,
  i18n,
  // beforeCreate() {
  //   Vue.prototype.$bus = this;
  // },

}).$mount('#app')